import { useCreateEntityElement } from 'client/context/CreateEntityContext'
import { getChildrenEntities } from 'client/reducers/pageReducer'
import { useWebsiteSettings } from 'client/store'
import React, { memo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { getWebsiteThemeBackground } from 'src/editor/store/website-settings/website-settings-selector'
import { CommonWebsiteLayoutBody } from 'src/shared/entities/website-layout-body'
import { WebsiteLayoutBodyInterface } from 'src/shared/types/website-entities'
import { getBackgroundImageStyleValue } from 'src/shared/utils/get-background-style-by-file'

export interface WebsiteLayoutBodyProps {
  entity: WebsiteLayoutBodyInterface
}

export const WebsiteLayoutBody = memo(({ entity }: WebsiteLayoutBodyProps) => {
  const { createEntityElement } = useCreateEntityElement()
  const layoutEntities = useSelector(
    // biome-ignore lint/suspicious/noExplicitAny: @TODO move selectors to typescript
    (state: any) => getChildrenEntities(state.page.present, entity.childIds),
    shallowEqual,
  )
  const background = useWebsiteSettings(getWebsiteThemeBackground)
  const backgroundImage = getBackgroundImageStyleValue(
    background?.pageBackgroundPicture?.file,
  )
  const header = createEntityElement(layoutEntities[0])
  const footer = createEntityElement(layoutEntities[1])
  const content = createEntityElement(layoutEntities[2])

  return (
    <CommonWebsiteLayoutBody
      header={header}
      content={content}
      footer={footer}
      backgroundImage={backgroundImage}
      background={background?.pageBackgroundColor}
    />
  )
})
